import { DatePicker, Space } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Moment } from "moment";
import { DATEPICKER_LOCALE, FILTERS_SECTION } from "../../constants/translates";

interface Props {
  onChange: (startDate: Moment | null, endDate: Moment | null) => void;
  startDate?: Moment | null;
  endDate?: Moment | null;
  allowClear?: boolean;
}

const DeclarantFilters: React.FC<Props> = ({
  onChange,
  startDate: sDate,
  endDate: eDate,
  allowClear = true,
}) => {
  const [startDate, setStartDate] = useState<Moment | null>(sDate || null);
  const [endDate, setEndDate] = useState<Moment | null>(eDate || null);

  const isInit = useRef(true);

  useEffect(() => {
    if (isInit.current) {
      isInit.current = false;
      return;
    }

    onChange(startDate, endDate);
  }, [startDate, endDate, onChange]);

  const disabledBeforeStart = (value: Moment): boolean => {
    if (startDate) {
      return value && value < startDate;
    }

    return false;
  };

  const disabledAfterEnd = (value: Moment): boolean => {
    if (endDate) {
      return value && value > endDate;
    }

    return false;
  };

  const onChangeStartDateHandler = (value: Moment | null) => {
    setStartDate(value);
  };

  const onChangeEndDateHandler = (value: Moment | null) => {
    setEndDate(value);
  };

  return (
    <Space className={'w-full'} direction="horizontal" align="center">
      <DatePicker
        locale={DATEPICKER_LOCALE}
        placeholder={FILTERS_SECTION.startDate}
        value={startDate}
        onChange={onChangeStartDateHandler}
        disabledDate={disabledAfterEnd}
        allowClear={allowClear}
      />
      <span className="divider">-</span>
      <DatePicker
        locale={DATEPICKER_LOCALE}
        placeholder={FILTERS_SECTION.endDate}
        value={endDate}
        onChange={onChangeEndDateHandler}
        disabledDate={disabledBeforeStart}
        allowClear={allowClear}
      />
    </Space>
  );
};

export default DeclarantFilters;
